import React from 'react';
import { renderToString } from 'react-dom/server';
import MarkupMenuLinkIcon from 'components/pspdf/components/markup-menu/components/markup-menu-link-icon';
import {
  Separator,
  MarkupMenuIcon,
  NameIcon,
  HighlightIcon,
  StrikethroughIcon,
  UnderlineIcon,
} from './style';

import { ServerStyleSheet } from 'styled-components';

const sheet = new ServerStyleSheet();

interface MarkupMenuProps {
  annotation: any;
  showFinishLinkAction: boolean;
  showDeleteLinkAction: boolean;
  instance: any;
  actions: {
    showNameEditor: Function;
    onStartLinking: Function;
    onFinishLinking: Function;
    onDeleteLink: Function;
  };
}

export const linkButtonIds = {
  link: 'Cortlex-Link-Icon',
  finish: 'Cortlex-Link-Icon-Dashed',
  delete: 'Cortlex-Link-Icon-Delete',
};

export const decorationIconIds = {
  highlight: 'Cortlex-Highlight-Icon',
  underline: 'Cortlex-Underline-Icon',
  strikethrough: 'Cortlex-Strikethrough-Icon',
};

export const markupMenuIconIds = {
  ...linkButtonIds,
  ...decorationIconIds,
  name: 'Cortlex-Name-Icon',
};

export function MarkupMenu({
  annotation,
  showFinishLinkAction,
  showDeleteLinkAction,
  instance,
  actions,
}: MarkupMenuProps) {
  const { decorations = [], name } = annotation.toJS().customData || {};

  return (
    <div id="Cortlex-Container">
      <MarkupMenuIcon id={markupMenuIconIds.name} selected={name}>
        <NameIcon />
      </MarkupMenuIcon>
      <Separator />
      <MarkupMenuLinkIcon
        annotation={annotation}
        instance={instance}
        onStartLinking={actions.onStartLinking}
        onFinishLinking={actions.onFinishLinking}
        onDeleteLink={actions.onDeleteLink}
        showFinishLinkAction={showFinishLinkAction}
        showDeleteLinkAction={showDeleteLinkAction}
      />

      <MarkupMenuIcon
        id={markupMenuIconIds.highlight}
        selected={decorations.includes('highlight')}>
        <HighlightIcon />
      </MarkupMenuIcon>
      <MarkupMenuIcon
        id={markupMenuIconIds.underline}
        selected={decorations.includes('underline')}>
        <UnderlineIcon />
      </MarkupMenuIcon>
      <MarkupMenuIcon
        id={markupMenuIconIds.strikethrough}
        selected={decorations.includes('strikethrough')}>
        <StrikethroughIcon />
      </MarkupMenuIcon>
    </div>
  );
}

export function CustomMarkupMenu(reactElement) {
  const container = document.createElement('section');
  container.setAttribute('id', 'Cortlex-Root');
  container.classList.add('Cortlex-Hidden');

  const html = renderToString(sheet.collectStyles(reactElement));

  const styleTags = sheet.getStyleTags();

  container.innerHTML = styleTags + html;

  return container;
}
